import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from '../globals';
import { Response } from '../interface/response';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  headers = new HttpHeaders()
  .set('Access-Control-Allow-Origin', '*');

  constructor( private http: HttpClient, private globals: Globals) {
    this.globals = globals;
  }
  
  // getContacts() {
  //   return this.http.get(this.globals.apiUrl+'/contactos');
  // }

  saveContact(email) {
    let data:any = {
      'nombre': 'NUEVO!!!',
      'email': email,
      'mensaje': 'en espera de datos...'
    };
    return this.http.post<any>(this.globals.apiUrl+'/contactos/', {contacto: data}, { 'headers': this.headers });
  }

}
